import React, { useState, useEffect, useMemo } from "react";
import { NavLink } from "react-router-dom";
import Logo from "../../imagens/logo-azul";
import Fundo from "../../imagens/fundo-qrpedir-min.png";
import { Button, Card, Grid, TextField, Box } from "@mui/material";
import AuthService from "../../AuthService";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";

const SignIn = () => {
  const [form, setForm] = useState({ username: "", password: "" });
  const { enqueueSnackbar } = useSnackbar();
  const [acessando, setAcessando] = useState(false);
  const navigate = useNavigate();
  const auth = useMemo(() => new AuthService(), []);

  useEffect(() => {
    if (auth.loggedIn()) navigate("/");
    document.title = "QR Pedir - Login";
  }, [auth, navigate]);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleLogin = (msg, options) => {
    enqueueSnackbar(msg, options);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const md5 = require("js-md5");
    setAcessando(true);

    auth
      .login(form.username, md5(form.password))
      .then((res) => {
        let ativo = res.empresa?.ativo ?? true;
        let admin = res.admin ?? false;

        if (res.id != null) {
          if (!ativo && !admin) {
            auth.logout();
            navigate("/Inativo");
          } else {
            setAcessando(false);
            handleLogin("Login realizado com sucesso", { variant: "success" });
            navigate("/Cardapio");
          }
        } else if (res.text === "BLOCK_EMPRESA") {
          navigate("/Block");
        } else if (res.text === "BLOCK_EMPRESA_TEMPORARIA") {
          navigate("/TempoExpirado", { state: { tipo: res.tipo } });
        }
      })
      .catch((err) => {
        setAcessando(false);
        if (!err.response) {
          handleLogin("Falha ao se comunicar com servidor", {
            variant: "error",
          });
        } else {
          err.response.json().then((elem) => {
            handleLogin(elem.errorMessage, { variant: "error" });
          });
        }
      });
  };

  return (
    <Box
      style={{ height: "100vh", background: `url(${Fundo}) repeat` }}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Box display="flex" justifyContent="center" p={4} mt={6}>
        <Logo
          style={{ width: "15vw", minWidth: "200px", height: "auto" }}
          alt="logo"
        />
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="flex-start"
        style={{ height: "800px" }}
      >
        <Card
          sx={{
            padding: "2vw",
            paddingBottom: 0,
            width: "30vw",
            minWidth: "300px",
            maxWidth: "450px",
            maxHeight: "500px",
            margin: "100px auto",
          }}
        >
          <Box p={3}>
            <form onSubmit={handleFormSubmit}>
              <Grid>
                <Grid container justifyContent="center">
                  <TextField
                    label="E-mail"
                    variant="outlined"
                    name="username"
                    fullWidth
                    onChange={handleChange}
                    sx={{ margin: 1 }}
                  />
                  <TextField
                    label="Senha"
                    type="password"
                    variant="outlined"
                    name="password"
                    fullWidth
                    onChange={handleChange}
                    sx={{ margin: 1 }}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    size="large"
                    disabled={acessando}
                    sx={{
                      backgroundColor: "#253257",
                      color: "white",
                      borderRadius: "50px",
                      height: "48px",
                      width: "40%",
                      marginTop: "30px",
                      "&:hover": {
                        backgroundColor: "#E9E9E9",
                        color: "#253257",
                      },
                    }}
                  >
                    {acessando ? "ENTRANDO..." : "ENTRAR"}
                  </Button>
                </Grid>

                <Grid container justifyContent="center">
                  <Button
                    href="/NovaEmpresaUser"
                    sx={{
                      color: "#253257",
                      marginBottom: "60px",
                      "&:hover": {
                        background: "transparent",
                        color: "#253257",
                      },
                    }}
                  >
                    Cadastrar-se
                  </Button>
                </Grid>

                <Grid container justifyContent="center">
                  <NavLink
                    to="/RecuperarSenha"
                    style={{ color: "#253257", textDecoration: "none" }}
                  >
                    Recuperar senha
                  </NavLink>
                </Grid>
              </Grid>
            </form>
          </Box>
        </Card>
      </Box>
    </Box>
  );
};

export default SignIn;
